export default {
  it: {
    footer: {
      hourTable: `Orari di apertura`,
      location: `Dove siamo`,
      phone: `Telefono: {phone}`,
      email: `E-mail: {email}`
    },
    days: {
      monday: 'Lunedì',
      tuesday: 'Martedì',
      wednesday: 'Mercoledì',
      thursday: 'Giovedì',
      friday: 'Venerdì',
      saturday: 'Sabato',
      sunday: 'Domenica',
    }
  },
  en: {
    "footer": {
      "hourTable": "Opening Hours",
      "location": "Where We Are",
      "phone": "Phone: {phone}",
      "email": "Email: {email}"
    },
    "days": {
      "monday": "Monday",
      "tuesday": "Tuesday",
      "wednesday": "Wednesday",
      "thursday": "Thursday",
      "friday": "Friday",
      "saturday": "Saturday",
      "sunday": "Sunday"
    }
  }
}
